import { UTILITY_TYPES } from './utilityType';

export const SECTOR_ID_ELECTRICITY = '01';
export const SECTOR_ID_GAS = '02';

export const UTILITY_TYPE_TO_SECTOR_ID = {
  [UTILITY_TYPES.ELECTRIC_ENERGY]: SECTOR_ID_ELECTRICITY,
  [UTILITY_TYPES.NATURAL_GAS]: SECTOR_ID_GAS
};